import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getTokens } from '../../theme';
import { useContext } from 'react';
import { DataContext } from '../../context/DataContext';

// Tab bar segmentada — ver README.md (SegmentedTabs).
// tabs: [{ label, count?, icon? }]
const SegmentedTabs = ({ tabs, value, onChange, sx }) => {
	const theme = useTheme();
	const { isDarkMode } = useContext(DataContext);
	const t = getTokens(isDarkMode);

	return (
		<Box
			sx={{
				display: 'inline-flex',
				backgroundColor: t.tabbar,
				padding: '3px',
				borderRadius: '10px',
				gap: '2px',
				flexWrap: 'wrap',
				...sx
			}}
		>
			{tabs.map((tab, index) => {
				const active = index === value;
				return (
					<Box
						key={tab.label}
						onClick={() => onChange(index)}
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: '7px',
							padding: '7px 15px',
							borderRadius: '8px',
							fontSize: 13,
							fontWeight: 600,
							cursor: 'pointer',
							color: active ? theme.palette.text.primary : t.ink3,
							backgroundColor: active ? theme.palette.background.paper : 'transparent',
							boxShadow: active ? '0 1px 3px rgba(0,0,0,.08)' : 'none',
							whiteSpace: 'nowrap'
						}}
					>
						{tab.icon}
						{tab.label}
						{tab.count !== undefined && tab.count !== null ? (
							<Box
								component="span"
								sx={{
									fontSize: 11,
									fontWeight: 600,
									padding: '1px 7px',
									borderRadius: '20px',
									backgroundColor: active ? t.soft : 'transparent',
									color: active ? theme.palette.text.primary : t.mut
								}}
							>
								{tab.count}
							</Box>
						) : null}
					</Box>
				);
			})}
		</Box>
	);
};

export default SegmentedTabs;
